import { useContext } from 'react';
import { OnStartWarningHook } from '../../../../_Common/Const/Rutiner';
import optionQuery from '../../../../../../../src/Components/QueryComponents/AvenySYSOptionQuery/AvenySYSOptionQuery.gql';
import {
  AvenySYSOptionQuery,
  AvenySYSOptionQueryVariables,
} from '../../../../../../../src/Components/QueryComponents/AvenySYSOptionQuery/_QueryTypes/AvenySYSOptionQuery';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export const useLeverantorFakturaOnStartWarningHook: OnStartWarningHook =
  isLoggedIn => {
    const activeDatabase = useContext(ActiveDatabaseContext);
    const { data, loading } = useQuery<
      AvenySYSOptionQuery,
      AvenySYSOptionQueryVariables
    >(optionQuery, {
      fetchPolicy: 'cache-and-network',
      variables: {
        dbName: activeDatabase.activeDatabase || '',
        subSystemCode: 'LR',
        optionKey: 'LR_ATTEST_NYAAVENY',
      },
      skip: !activeDatabase.activeDatabase || !isLoggedIn,
    });

    return {
      loading: loading,
      ok: !loading && data?.db?.SYSOptions_All?.[0]?.OptionData === 'Y',
      warningText:
        'Fakturaattest i Nya Aveny behöver aktiveras för att rutin Leverantörsfakturor ska kunna startas',
    };
  };
